var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.profileMetrics),function(profileMetric){return _c('SingleTextOnlineProfileMetric',{key:profileMetric.id,attrs:{"is-single-profile":false,"profileMetric":profileMetric}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }